function AddCartHandler(product, batches_enabled){
    const DEV_MODE = true;

    let variant = 0;
    let opening = false;
    let in_stock = true;

    let el_product_form = null;

    let el_cart_icon_container = document.getElementById('cart-count-widget-contaioner');
    let el_cart_count_text = document.getElementById('cart-count-display');
    let el_cart_icon_mobile_container = document.getElementById('cart-count-widget-mobile-contaioner');
    let el_cart_count_mobile_text = document.getElementById('cart-count-mobile-display');

    let el_cart_count_popup_text = document.getElementById('cart-count-popup-display');
    let el_add_to_cart_button = document.getElementById('add-to-cart-button');
    let el_add_to_cart_button_sticky = document.getElementById('sticky-add-to-cart-button');
    let el_add_to_cart_reviews = document.getElementById('reviews-add-to-cart-button');
    let el_popup_container = document.getElementById('product-popup-container');
    let el_count_input = document.getElementById('product-count-input');
    let el_close_modal = document.getElementById('product-modal-close');
    let el_close_modal_chevron = document.getElementById('product-modal-close-chevron');
    let el_increase_button = document.getElementById('product-count-increase');
    let el_decrease_button = document.getElementById('product-count-decrease');

    let el_empty_cart_button = document.getElementById('popup-remove-from-cart-link');

    let els_normal_out_of_stock_messages_containers = document.querySelectorAll('.product-page__stock__normal-out-of-stock');
    let els_custom_out_of_stock_containers = document.querySelectorAll('.product-page__stock__custom-out-of-stock');
    let els_custom_shipping_message_containers = document.querySelectorAll('.product-page__stock__custom-message-container');
    let els_custom_shipping_date_early = document.querySelectorAll('.product-page__stock__early-date');
    let els_custom_shipping_date_later = document.querySelectorAll('.product-page__stock__later-date');
    let els_custom_shipping_date_early_containers = document.querySelectorAll('.product-page__stock__early-date-container');
    let els_custom_shipping_multiple_dates_messages = document.querySelectorAll('.product-page__stock__multiple-results-message');

    let el_popup_price = document.querySelector('.product__popup-product-price');

    if (batches_enabled) {
        get_custom_shipping_info();
    }
    else {
        do_stock_check();
    }

    function init() {
        // Set event handlers.
        document.addEventListener('click', dismiss_modal_click);
        if(el_close_modal)
            el_close_modal.addEventListener('click', dismiss_modal_click);

        if(el_close_modal_chevron)
            el_close_modal_chevron.addEventListener('click', dismiss_modal_click);

        if(el_add_to_cart_button)
            el_add_to_cart_button.addEventListener('click', add_cart_clicked);

        if (el_add_to_cart_button_sticky) {
            el_add_to_cart_button_sticky.addEventListener('click', add_cart_clicked);
            el_add_to_cart_button_sticky.addEventListener('click', to_top);
        }

        if (el_add_to_cart_reviews) {
            el_add_to_cart_reviews.addEventListener('click', add_cart_clicked);
            el_add_to_cart_reviews.addEventListener('click', to_top);
        }
        if(el_count_input)
            el_count_input.addEventListener('change', count_changed);
        if(el_popup_container)
            el_popup_container.addEventListener('click', prevent_default);
        if(el_increase_button)
            el_increase_button.addEventListener('click', increase_clicked);
        if(el_decrease_button)
            el_decrease_button.addEventListener('click', decrease_clicked);
        if(el_empty_cart_button)
            el_empty_cart_button.addEventListener('click', remove_item_click);

        /* Optional input filtering */
        if (typeof NumberOnly === "function") {
            NumberOnly(el_count_input);
        }

        el_product_form = document.querySelector('.product-form');
        if (el_product_form) 
            el_product_form.addEventListener('submit', function(e){
                e.preventDefault();
                return false;
            });

        // If a variant passed on URL set the variant index
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams)
            if (urlParams.get('variant')) this.set_variant_by_id(urlParams.get('variant'));
    }

    function to_top() {
        window.scrollTo(0, 0);
    }

    function get_cart_count() {
        let xhr = new XMLHttpRequest();
        let url = "/cart.js";
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                update_cart_icon(d.item_count, extract_varient_count(d));
            }
        };
        xhr.send();
    }

    function get_custom_shipping_info() {
        let xhr = new XMLHttpRequest();
        let url = '';
        if (DEV_MODE) {
            url = "/apps/batch_shipping_dev/cart/product/estimate?product_id=" + product.id;
        }
        else {
            url = "/apps/batch_shipping/cart/product/estimate?product_id=" + product.id;
        }
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                update_shipping_info(d)
            }
            if (xhr.readyState === 4 && xhr.status === 500) {
                custom_shipping_service_down();
            }
            if (xhr.readyState === 4 && xhr.status !== 200) {
                do_stock_check();
            }
        };
        xhr.send();
    }

    function update_cart(count) {
        let xhr = new XMLHttpRequest();
        let url = "/cart/update.js";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                // let d = JSON.parse(this.responseText);
                // get_cart_count();
                forward_to_cart();
            }
        };
        let data_o = {
            updates: {}
        };
        data_o.updates[product.variants[variant].id] = count;
        let data = JSON.stringify(data_o);
        xhr.send(data);
    }

    function add_one_in_cart() {
        let xhr = new XMLHttpRequest();
        let url = "/cart.js";
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                var count = extract_varient_count(d);
                update_cart(d + 1);
            }
        };
        xhr.send();
    }

    function extract_varient_count(data) {
        let v = product.variants[variant].id;
        for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].variant_id == v) {
                return data.items[i].quantity;
            }
        }
        return 0;
    }

    function update_cart_icon(cart_count, product_count) {
        el_cart_count_text.innerHTML = cart_count;
        el_cart_count_mobile_text.innerHTML = cart_count;
        el_cart_count_popup_text.innerHTML = cart_count;
        el_count_input.value = product_count;
        if (cart_count == 0) {
            el_cart_icon_container.style['display'] = 'none';
            el_cart_icon_mobile_container.style['display'] = 'none';
        }
        else {
            el_cart_icon_container.style['display'] = 'block';
            el_cart_icon_mobile_container.style['display'] = 'block';
        }
    }

    function update_shipping_info(data) {
        if (data.status) {
            for (let i = 0; i < els_custom_shipping_message_containers.length; i++) {
                els_custom_shipping_message_containers[i].style['display'] = 'block';
            }
            if (data.express == 0) {
                for (let i = 0; i < els_custom_shipping_date_early_containers.length; i++) {
                    els_custom_shipping_date_early_containers[i].style['display'] = 'none';
                }
                for (let i = 0; i < els_custom_shipping_multiple_dates_messages.length; i++) {
                    els_custom_shipping_multiple_dates_messages[i].style['display'] = 'none';
                }
            }
            else {
                for (let i = 0; i < els_custom_shipping_date_early.length; i++) {
                    els_custom_shipping_date_early[i].innerHTML = data.estimated_date_express;
                }
            }
            for (let i = 0; i < els_custom_shipping_date_later.length; i++) {
                els_custom_shipping_date_later[i].innerHTML = data.estimated_date;
            }
        }
        else if(data.managed && !data.status && data.inventory_count < 1){
            // Is managed but no Batches available
            for (let i = 0; i < els_custom_out_of_stock_containers.length; i++) {
                els_custom_out_of_stock_containers[i].style['display'] = 'block';
            }
        }
        else if (!data.managed && data.inventory_count < 1){
            el_shipping_status_main_container.style['display'] = 'none';
            el_shipping_status_popup_container.style['display'] = 'none';
            if (data.inventory_count < 1) {
                // Show out of stock message
                el_add_to_cart_button.style['display'] = 'none';
                if (el_add_to_cart_button_sticky) {
                    el_add_to_cart_button_sticky.style['display'] = 'none';
                }
                for (let i = 0; i < els_normal_out_of_stock_messages_containers.length; i++) {
                    els_normal_out_of_stock_messages_containers[i].style['display'] = 'block';
                }
            }
        }
    }

    function custom_shipping_service_down() {
        /* If the service is down show the custom unable to determine message */
        for (let i = 0; i < els_custom_out_of_stock_containers.length; i++) {
            els_custom_out_of_stock_containers[i].style['display'] = 'block';
        }
    }

    function show_cart_modal() {
        el_popup_container.style['display'] = 'block';
    }

    function hide_cart_modal() {
        if (opening) {
            opening = false;
            return;
        }
        if(el_popup_container) {
            el_popup_container.style['display'] = 'none';
        }
    }

    function do_stock_check() {
        if(product.variants[variant].available) {
            // Hide the out of stock message
            for (let i = 0; i < els_normal_out_of_stock_messages_containers.length; i++) {
                els_normal_out_of_stock_messages_containers[i].style['display'] = 'none';
            }
            if(el_add_to_cart_button) {
                el_add_to_cart_button.style['display'] = 'block';
                if (el_add_to_cart_button_sticky) {
                    el_add_to_cart_button_sticky.style['display'] = 'block';
                }
            }
        }
        else {
            // Show the out of stock message
            for (let i = 0; i < els_normal_out_of_stock_messages_containers.length; i++) {
                els_normal_out_of_stock_messages_containers[i].style['display'] = 'block';
            }
            if(el_add_to_cart_button) {
                el_add_to_cart_button.style['display'] = 'none';
                if (el_add_to_cart_button_sticky) {
                    el_add_to_cart_button_sticky.style['display'] = 'none';
                }
            }
        }
    }

    function set_variant_display_price() {
        let price = product.variants[variant].price / 100;
        let currency_code = el_popup_price.innerText.substr(0, 1);
        el_popup_price.innerText = currency_code + price + ".00";
    }

    function forward_to_cart() {
        const locale = window.location.pathname.split('/')[1];
        if (locale.includes('en-')) {
            window.location = `/${locale}/cart`;
        } else {
            window.location = "/cart";
        }
    }

    /* External API */
    this.set_variant_by_id = function(vid) {
        for (let i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id == vid) {
                variant = i;
                set_variant_display_price();
                if (!batches_enabled) {
                    do_stock_check();
                }
                break;
            }
        }
    }

    this.set_variant_by_name = function(name) {
        for (let i = 0; i < product.variants.length; i++) {
            if (product.variants[i].public_title == name || product.variants[i].title == name) {
                variant = i;
                set_variant_display_price();
                if (!batches_enabled) {
                    do_stock_check();
                }
                break;
            }
        }
    }

    /* UI event handlers */
    function add_cart_clicked(e) {
        
        // show_cart_modal();
        add_one_in_cart();
        // opening = true;
    }

    function remove_item_click(e) {
        update_cart(0);
        hide_cart_modal();
    }

    function count_changed(e) {
        update_cart(el_count_input.value);
    }

    function increase_clicked(e) {
        let count = parseInt(el_count_input.value);
        el_count_input.value = count + 1;
        update_cart(el_count_input.value);
    }

    function decrease_clicked(e) {
        let count = parseInt(el_count_input.value);
        if (count > 0) {
            el_count_input.value = count - 1;
            update_cart(el_count_input.value);
        }
    }

    function dismiss_modal_click(e) {
        hide_cart_modal();
    }

    function prevent_default(e) {
        e.stopPropagation();
    }

    init();
    return this;
};
